<template>
  <dashboard-topbar/>
  <div class="main">
    <div class="mainContent">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 pr-0">
            <dashboard-navbar/>
          </div>
          <div class="col-lg-9 pl-0">
            <div class="cabinet-content">
              <div class="register">
                <div class="container">
                  <template v-if="!isLoading">
                    <div class="title">
                      <h1>{{ $t('EmailVerification') }}</h1>
                    </div>

                    <div class="col-xs-12 col-md-12 col-lg-6 offset-lg-3">
                      <template v-if="currentUser">
                        <div class="verification-body">
                          <template v-if="currentUser.is_verified_email">
                            <div class="success-animation">
                              <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                                <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                              </svg>
                            </div>
                            <h3>{{ $t('YourEmailHasBeenSuccessfullyVerified') }}</h3>
                            <router-link type="button" class="btn btn-success mt-20" :to="{name: 'profile'}">
                              {{ $t('Continue') }}...
                            </router-link>
                          </template>
                          <template v-else>
                            <h3>{{ $t('WeHaveSentAVerificationLetterToYourEmailFollowTheLinkProvidedInIt') }}</h3>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <dashboard-preloader/>
                      </template>
                    </div>
                  </template>
                  <template v-if="isLoading">
                    <dashboard-preloader/>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardTopbar from "@/components/Topbar.vue";
import DashboardNavbar from "@/components/Navbar.vue"
import DashboardPreloader from "@/components/Preloader.vue";
import {getterTypes, actionTypes} from "@/store/modules/auth";
import {mapGetters} from "vuex";

export default {
  name: 'DashboardEmailVerification',
  components: {
    DashboardPreloader,
    DashboardTopbar,
    DashboardNavbar,
  },
  mounted() {
    const key = this.key;
    if (key === undefined){
      console.log("Email verification key: ", key)
      this.$store.dispatch(actionTypes.sendVerifyMailLink)
    } else {
      this.$store.dispatch(actionTypes.verificationEmail, {key: key}).then(() => {
        this.$store.dispatch(actionTypes.getCurrentUser)
      })
    }
  },
  computed: {
    ...mapGetters({
      isLoading: getterTypes.isLoading,
      currentUser: getterTypes.currentUser,
    }),
    key(){
      return this.$route.query.key
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";
  @import "@/scss/mixins";


  .pr-0{
    padding-right: 0;
  }
  .pl-0{
    padding-left: 0;
  }

  .main {
    margin-top: 86px;

    &Content {
      margin-top: 0;
    }

    .cabinet-content{
      min-height: 100vh;
      padding-left: 40px;
      border-left: 1px solid #e9e9e9;
      overflow: hidden;
      .register {
        margin-top: 85px;
        .title {
          margin-bottom: 40px;
          text-align: center;
        }
        .verification-body{
          text-align: center;
          color: $fi;
        }
      }
    }

    .success-animation {
      margin: 55px auto;
    }
    .checkmark {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      display: block;
      stroke-width: 2;
      stroke: #4bb71b;
      stroke-miterlimit: 10;
      box-shadow: inset 0px 0px 0px #4bb71b;
      animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
      position: relative;
      top: 5px;
      right: 5px;
      margin: 0 auto;
    }
    .checkmark__circle {
      stroke-dasharray: 166;
      stroke-dashoffset: 166;
      stroke-width: 2;
      stroke-miterlimit: 10;
      stroke: #4bb71b;
      fill: #fff;
      animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
    }
    .checkmark__check {
      transform-origin: 50% 50%;
      stroke-dasharray: 48;
      stroke-dashoffset: 48;
      animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
    }
    @keyframes stroke {
      100% {
        stroke-dashoffset: 0;
      }
    }
    @keyframes scale {
      0%, 100% {
        transform: none;
      }
      50% {
        transform: scale3d(1.1, 1.1, 1);
      }
    }
    @keyframes fill {
      100% {
        box-shadow: inset 0px 0px 0px 30px #4bb71b;
      }
    }
  }
</style>
